export default "__VITE_ASSET__Y5WyrkgV$QGF1zTT7y$F7w__"